import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useT } from "@/context/LanguageContext";
import { ArrowUpRight } from "@phosphor-icons/react";

export function CurrencyTicker() {
  const { t } = useT();
  const [data, setData] = useState({ base: "USD", rates: [] });

  useEffect(() => {
    api.get("/tools/rates").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const list = data.rates.filter((r) => r.code !== data.base);
  if (!list.length) return null;
  const items = [...list, ...list];

  return (
    <Link
      to="/tools"
      data-testid="currency-ticker"
      className="group relative flex items-center overflow-hidden border-y border-white/10 bg-ink py-3 text-white"
      title={t("currency.note")}
    >
      <div className="z-10 flex shrink-0 items-center gap-2 bg-ink px-4 shadow-[8px_0_12px_rgba(10,25,47,0.9)]">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-teal opacity-75" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-teal" />
        </span>
        <span className="font-mono text-xs font-semibold uppercase tracking-widest text-teal-light">
          {t("currency.live")}
        </span>
      </div>

      <div className="flex w-max animate-marquee items-center gap-9 pl-6 group-hover:[animation-play-state:paused]">
        {items.map((r, i) => (
          <span key={`${r.code}-${Math.floor(i / list.length)}`} className="flex items-center gap-2 whitespace-nowrap text-sm" data-testid="ticker-item">
            <span className="text-base leading-none">{r.flag}</span>
            <span className="text-slate-400">1 {data.base} =</span>
            <span className="font-mono font-semibold text-white">{r.rate}</span>
            <span className="font-semibold text-teal-light">{r.code}</span>
            <span className="text-xs text-slate-500">· {r.country}</span>
          </span>
        ))}
      </div>

      <div className="z-10 hidden shrink-0 items-center gap-1 bg-ink px-4 text-xs font-semibold text-teal-light shadow-[-8px_0_12px_rgba(10,25,47,0.9)] sm:flex">
        {t("nav.tools")} <ArrowUpRight size={13} weight="bold" />
      </div>
    </Link>
  );
}
